import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_PHOTO_UPLOAD_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_PHOTO_UPLOAD_SUCCESS`;
export const INTELLIGENT_PHOTO_CAPTURE_PHOTO_UPLOAD_FAILURE = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_PHOTO_UPLOAD_FAILURE`;
export const photoCaptureIntelligentPhotoUploadSuccessAction = files => ({
    type: INTELLIGENT_PHOTO_CAPTURE_PHOTO_UPLOAD_SUCCESS,
    payload: { files }
});
export const photoCaptureIntelligentPhotoUploadFailureAction = failureMessage => ({
    type: INTELLIGENT_PHOTO_CAPTURE_PHOTO_UPLOAD_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=photoCaptureIntelligentPhotoUploadActions.js.map